import { Box, Card } from '@mui/material';

import { Text, colors } from 'common';

import { StickyNoteTextField } from './Field';
import { StickyNoteToolbar } from './Toolbar/Toolbar';
import { FlowUiMode, useReactFlowViewContext } from '../../../context/context';
import { type ReactFlowStickyNoteNodeProps } from '../BlockType/types';
import { ReactFlowDecoratorNodeResizer } from '../Decorations/NodeResizer';
import { FLOW_DECORATION_COLORS } from '../Decorations/constants';
import {
  REACT_FLOW_CARD_DEFAULT_BOX_SHADOW,
  REACT_FLOW_CARD_HIGHLIGHTED_BOX_SHADOW,
} from '../constants';

const MIN_WIDTH = 240;
const MIN_HEIGHT = 144;

export function StickyNoteCard(props: ReactFlowStickyNoteNodeProps) {
  const {
    selected,
    width = MIN_WIDTH,
    height = MIN_HEIGHT,
    data: { author, color },
  } = props;
  const { isEditable, uiMode } = useReactFlowViewContext();

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          position: 'relative',
          border: '1px solid',
          ...FLOW_DECORATION_COLORS[color],
          boxShadow: REACT_FLOW_CARD_DEFAULT_BOX_SHADOW,
          '&:hover': {
            boxShadow: REACT_FLOW_CARD_HIGHLIGHTED_BOX_SHADOW,
          },
          width: Math.max(width, MIN_WIDTH),
          height: Math.max(height, MIN_HEIGHT),
          overflow: 'hidden',
          padding: 2,
          paddingBottom: 2.5,
          opacity: uiMode === FlowUiMode.Run ? 0.5 : undefined,
        }}
        className={selected ? 'nowheel' : undefined} // Allows scrolling the text area when focused (blocking react-flow zoom)
        /**
         * Prevent cut/copy/paste events from bubbling up to ReactFlow
         * which would otherwise trigger node copy/paste
         */
        onCut={(event) => {
          event.stopPropagation();
        }}
        onCopy={(event) => {
          event.stopPropagation();
        }}
        onPaste={(event) => {
          event.stopPropagation();
        }}
      >
        <Text
          variant="subtitle2"
          sx={{ position: 'absolute', bottom: 2, left: 16 }}
          color={colors.extended.gray[55]}
        >
          {author}
        </Text>
        <Box
          sx={{
            height: '100%',
          }}
        >
          <StickyNoteTextField {...props} />
        </Box>
      </Card>
      {isEditable && <StickyNoteToolbar {...props} />}
      {isEditable && (
        <ReactFlowDecoratorNodeResizer
          selected={selected}
          decorationColor={color}
          minWidth={MIN_WIDTH}
          minHeight={MIN_HEIGHT}
        />
      )}
    </>
  );
}
